import ApplicationController from "application_controller.js";

//* Lets a link to a section of the current page jump straight to it, like a
//* plain "#section" link. Turbo otherwise fetches and renders the whole page
//* again for "/#section" while the visitor is already on "/".
//* Attach on an element that holds the links, for example the body:
//*   <body data-controller="section-link" data-action="turbo:click->section-link#jump click->section-link#clearHeader">
export default class extends ApplicationController {
  debug = false;

  //* Cancel the Turbo visit, so that the browser does its own jump to the section
  jump(event) {
    if (!this.sectionFor(new URL(event.detail.url))) return;

    this.log_function("jump", event.detail.url);
    event.preventDefault();
  }

  //* The header slides back in while the page scrolls up, so a section above
  //* the viewport stops below the header. Scrolling down hides the header, so
  //* a section below the viewport stops at the top. Runs before the jump.
  clearHeader(event) {
    const link = event.target.closest("a[href]");
    const section = link && this.sectionFor(new URL(link.href));
    if (!section) return;

    this.log_function("clearHeader", link.hash);
    section.style.scrollMarginTop = section.getBoundingClientRect().top < 0 ? "var(--gt-header-height)" : "";
  }

  //* The element a URL points to on the current page, or null
  sectionFor(url) {
    if (!url.hash || url.pathname + url.search !== location.pathname + location.search) return null;

    return document.getElementById(decodeURIComponent(url.hash.slice(1)));
  }
}
